import React from "react";
import classnames from "classnames";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

import BannerAdContainer from "@/app/pages/companyProfile/bannerAdContainer/BannerAdContainer";
import { isNotUndefined } from "@/shared/FunctionCore";
import "@/styles/companyProfile/HooversAdStyles.scss"
import dnbLogoWhite from "@/resources/logo-dnb-hoovers-white.svg";

const HooversAdBlockBackup = ({
  forPage
}): JSX.Element => {
  const { t } = useTranslation();
  const { pathname } = useLocation();

  const contents: string[] = t(`${forPage}.hooversOrangeBanner.contents`, { returnObjects: true });
  const isContactIndustryPage = pathname.includes("contact-industry-search")

  return (
    <BannerAdContainer
      bodyClass={`dnb-hoovers-free-trial-ad ${isContactIndustryPage ? "my-3" :  ""}`}
      forPage={forPage}
    >
      <div className={classnames({
        "col-md-10 row dnbHooversCta": true,
        "hooversBackgroundImgSize": forPage === "contactProfile"
      })}>
        <div className={classnames({
          "d-flex align-items-center": true,
          "col-md-3 px-2": forPage === "contactProfile",
          "col-md-4": forPage === "companyProfile"
        })}>
          <img
            alt="D&amp;B Hoovers Logo"
            className={classnames({
              "dnbHooversCtaImg img-responsive": true,
              "spacing-mt-2 h-38": forPage === "contactProfile"
            })}
            src={dnbLogoWhite}
          />
        </div>
        <div className={forPage === "companyProfile" ? "col-md-7" : "col-md-6 pl-26"}>
          <div className={classnames({
            "dnbHooversCtaCopy": true,
            "font16": forPage === "contactProfile"
          })}>
            {/* <p className="dnbHooversCtaCopyText"> {t(`${forPage}.hooversOrangeBanner.description`)}</p>
          <p className="dnbHooversCtaCopyText"> {t(`${forPage}.hooversOrangeBanner.subDescription`)}</p> */}
            {isNotUndefined(contents) && contents.map((para: string, i) =>
              <p className="dnbHooversCtaCopyText" key={i}>{para}</p>
            )}
          </div>

        </div>
        {forPage === "companyProfile" && <div className="col-md-4"></div>}
        <div className={classnames({
          "spacing-mt-2": true,
          "col-md-3-hoovers  hoovers-free-trial": forPage === "contactProfile",
          "col-md-5": forPage === "companyProfile"
        })}>
          <a
            className={classnames({
              "hoovers-free-trial-button": forPage === "contactProfile",
              "dnbHooversTrialCtaAnchor button-tertiary": forPage === "companyProfile"
            })}
            href={t(`${forPage}.hooversOrangeBanner.buttonLink`)}
            aria-label="D&B Hoovers Free Trial Button"
            // onClick="track_event('hoovers-free-trial-link-clicked');"
          >
            {t(`${forPage}.hooversOrangeBanner.buttonLabel`)}
          </a>
        </div>
      </div>
    </BannerAdContainer>
  )
}

export default HooversAdBlockBackup